import { ColumnDescription } from "react-bootstrap-table-next";
import ExportExcel from "../../../Components/StickyToolbar/ExportExcel";
import Table from "../../../Components/Table";
import LeiaMais from "../../../Components/Utils/LeiaMais";
import {
    AnaliseDeCreditoController,
    ExportarExcelAnaliseDeCreditoController,
} from "../../../Controllers/Vendas/AnaliseDeCredito/AnaliseDeCreditoControllers";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import {
    IAnalisesDeCredito,
    IAnalisesDeCreditoBody,
} from "../../../Interfaces/Vendas/GestaoAtendimentos/AnaliseDeCredito/AnaliseDeCreditoInterfaces";
import { formatMoneyReais } from "../../../Tools/FormatTools";
import StorageManagerCapys from "../../../Tools/Storage";
import CardViewAnaliseDeCredito from "./CardViewAnaliseDeCredito";
import AnaliseDeCreditoFiltro from "./FiltroAnaliseDeCredito";

const filterStorage = new StorageManagerCapys<IAnalisesDeCreditoBody>(
    "FILTRO_GESTAO_ANALISE_CREDITO"
);

export default function AnaliseDeCredito() {
    const { PageFilter, setPage, filter, setPageFilter } =
        usePaginationFilter<IAnalisesDeCreditoBody>({ page: 1 });

    const { value: AnaliseDeCreditoLst, loading: AnaliseDeCreditoLstLoading } =
        useAsyncEffect(async () => {
            return AnaliseDeCreditoController(PageFilter.page, {
                ...(PageFilter.filter ?? 0),
                ID_CASO: PageFilter.filter?.ID_CASO ?? 0,
                FL_DESISTENCIA: PageFilter.filter?.FL_DESISTENCIA || 2,
                FL_VENDA: PageFilter.filter?.FL_VENDA || 2,
                ID_PRODUTO: PageFilter.filter?.ID_PRODUTO ?? 0,
                ID_PRODUTOS: PageFilter.filter?.ID_PRODUTOS ?? [],
                ID_USUARIO_RESPONSAVEL:
                    PageFilter.filter?.ID_USUARIO_RESPONSAVEL ?? 0,
            });
        }, [PageFilter]);

    const totalPaginas = AnaliseDeCreditoLst?.NR_PAGINAS || 1;

    const dataColumns: Array<ColumnDescription> = [
        {
            dataField: "ID_RESERVA",
            text: "Analise de Crédito",
            formatter: (c, row) => <CardViewAnaliseDeCredito {...row} />,
        },
    ];

    const tableViewColumns: Array<ColumnDescription<IAnalisesDeCredito>> = [
        {
            dataField: "ID_CASO",
            text: "Solicitação",
            headerClasses: "font-size-h8 font-weight-bold",
        },
        {
            dataField: "DS_NOME_CONTA",
            text: "Cliente / Contato",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>
                    <h5>{row.DS_CONTA}</h5>
                    {/* <span>{row.NR_TELEFONE && FormatarNumeroTelefone(row.NR_TELEFONE)}</span> */}
                </div>
            ),
        },
        {
            dataField: "DS_STATUS",
            text: "Análise",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>
                    <div style={{ color: CorDaAnalise(row), fontSize: 16 }}>
                        {row.DS_STATUS}
                    </div>
                    {row.DS_ANALISE_CREDITO_STATUS && (
                        <div>Sub-Status: {row.DS_ANALISE_CREDITO_STATUS}</div>
                    )}
                </div>
            ),
        },
        {
            dataField: "VL_SUBSIDIO",
            text: "Valor",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <h5>
                    {formatMoneyReais(
                        row.VL_SICAQ_APROVADO + row.VL_FGTS + row.VL_SUBSIDIO
                    )}
                </h5>
            ),
        },
        {
            dataField: "DS_USUARIO_ANALISE",
            text: "Analista de Crédito",
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
        },
        {
            dataField: "DS_USUARIO_RESPONSAVEL_CASO",
            text: "Corretor / Equipe	",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>
                    <h5>{row.DS_USUARIO_RESPONSAVEL}</h5>
                    <span>{row.DS_EQUIPE_VENDAS_RESPONSAVEL}</span>
                </div>
            ),
        },
        {
            dataField: "DS_ULTIMO_HISTORICO",
            text: "Último Comentário",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>
                    <div>
                        {new Date(row.DT_ULTIMO_HISTORICO).toLocaleString()}
                    </div>
                    <LeiaMais charLimit={30}>
                        {row.DS_ULTIMO_HISTORICO}
                    </LeiaMais>
                    <p>Responsável: {row.DS_USUARIO_RESPONSAVEL}</p>
                </div>
            ),
        },
        {
            dataField: "DT_CRIACAO",
            text: "Início / Fim / Prazo",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>
                    <span className="bold">
                        Início: {c ? new Date(c).toLocaleString() : "-"}
                    </span>
                    {/* <div>
                        {row.NR_SLA <= 0 && row.DT_CONCLUSAO === null ? (
                            <>
                                <span
                                    className="rounded-circle"
                                    style={{
                                        height: 13,
                                        width: 13,
                                        display: "inline-block",
                                        marginRight: 5,
                                        backgroundColor: "red",
                                    }}
                                ></span>
                                <span className="mt-n2">
                                    A análise está atrasada a{" "}
                                    {Math.abs(row.NR_SLA - 1)}{" "}
                                    {row.NR_SLA === 0 ? "dia" : "dias"}
                                </span>
                            </>
                        ) : (
                            <span className="mt-8">
                                Fim{" "}
                                {row.DT_CONCLUSAO
                                    ? new Date(
                                          row.DT_CONCLUSAO
                                      ).toLocaleString()
                                    : "-"}
                            </span>
                        )}
                    </div> */}
                </div>
            ),
        },
    ];

    function CorDaAnalise(row: IAnalisesDeCredito) {
        if (row.DS_STATUS === "REPROVADA") {
            return "red";
        } else if (row.DS_STATUS === "APROVADA") {
            return "green";
        } else if (row.DS_STATUS === "PENDÊNCIA") {
            return "DarkMagenta";
        } else if (row.DS_STATUS === "EM ANÁLISE") {
            return "blue";
        }
    }

    return (
        <>
            <div className="card card-custom p-10">
                <h4 className="mb-5">Análise de Crédito</h4>
                <Table
                    keyField="ID_CASO"
                    columns={dataColumns}
                    wrapperClasses="mw-100 custom-scroll"
                    tableView={{
                        columns: tableViewColumns,
                        sizePerPage: 10,
                        cancelYScroll: true,
                        defaultStyle: true,
                        striped: true,
                    }}
                    remote={{ pagination: true }}
                    data={AnaliseDeCreditoLst?.Analises || []}
                    loading={AnaliseDeCreditoLstLoading}
                    onTableChange={(type, newState) => {
                        setPage(newState.page);
                    }}
                    totalPages={totalPaginas}
                    noDataIndication={() => (
                        <div className="text-black-50 text-center">
                            Nenhuma análise de crédito encontrada
                        </div>
                    )}
                    rowStyle={{ height: 80 }}
                    bordered={false}
                    defaultStyle={{ align: "center" }}
                    striped={false}
                    rowClasses={"rowClasses"}
                />
            </div>
            <AnaliseDeCreditoFiltro
                handleSubmit={(formData) => {
                    setPageFilter({
                        filter: formData,
                        page: 1,
                    });
                }}
                storageManager={filterStorage}
                defaultFilter={filter}
            />
            <ExportExcel
                baixarExcelController={async () =>
                    ExportarExcelAnaliseDeCreditoController({
                        ...(PageFilter.filter ?? 0),
                        ID_CASO: PageFilter.filter?.ID_CASO ?? 0,
                        FL_DESISTENCIA: PageFilter.filter?.FL_DESISTENCIA || 2,
                        FL_VENDA: PageFilter.filter?.FL_VENDA || 2,
                        ID_PRODUTO: PageFilter.filter?.ID_PRODUTO ?? 0,
                        ID_PRODUTOS: PageFilter.filter?.ID_PRODUTOS ?? [0],
                        ID_USUARIO_RESPONSAVEL:
                            PageFilter.filter?.ID_USUARIO_RESPONSAVEL ?? 0,
                    })
                }
                nomeArquivo={"Fila_Atendimentos_Cobranca"}
            />
        </>
    );
}
